import { useMsal } from "@azure/msal-react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

export const PrivateRoutes = () => {
	const location = useLocation();
	const { instance } = useMsal();

	if (instance === undefined) {
		return null; // or loading indicator/spinner/etc
	}

	return instance
		? <Outlet />
		: <Navigate to="/" replace state={{ from: location }} />;
}